import { G_DEF_COV } from "../../constants/globalVar";

const PartnerSliders = ({ items = [], active = "" }) => {
  return (
    <div className={`carousel-item ${active} py-3`} style={{ minHeight: '5rem' }}>
      <div className="container py-4">
        <div className="row justify-content-center align-items-center g-4">
          {items.map((item, index) => (
            <div key={item._id} className="col-6 col-md-4 col-lg-3 text-center text-decoration-none">
              {item.link ? (
                <a href={item.link} target="_blank" rel="noopener noreferrer">
                  <img
                    src={item.logo_img?.src || G_DEF_COV}
                    alt={item.name}
                    className="img-fluid rounded shadow-sm"
                    style={{ maxHeight: '120px', objectFit: 'contain' }}
                  />
                  <p className="mt-2 text-dark fw-semibold small">{item.name}</p>
                </a>
              ) : (
                <>
                  <img
                    src={item.logo_img?.src || G_DEF_COV}
                    alt={item.name}
                    className="img-fluid rounded shadow-sm"
                    style={{ maxHeight: '120px', objectFit: 'contain' }}
                  />
                  <p className="mt-2 text-dark fw-semibold small">{item.name}</p>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PartnerSliders;
